import React from 'react';
import PropTypes from 'prop-types';

function IconPause({ color = '#88898B', size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4038_62966)">
        <path d="M7.54036 5.63849H5.79697V10.8264H7.54036V5.63849Z" fill={color}/>
        <path d="M10.1079 5.63849H8.36453V10.8264H10.1079V5.63849Z" fill={color}/>
        <path d="M10.1079 1.47547V2.88075C12.1894 3.72604 13.6792 5.75472 13.6792 8.14264C13.6792 11.2702 11.1328 13.8272 7.99472 13.8272C4.8566 13.8272 2.32075 11.2808 2.32075 8.15321C2.32075 5.76528 3.8 3.7366 5.89208 2.89132V1.47547C3.06038 2.37358 1 5.02566 1 8.15321C1 12.0098 4.13811 15.1479 7.99472 15.1479C11.8513 15.1479 14.9894 12.0098 14.9894 8.15321C14.9894 5.02566 12.9291 2.38415 10.1079 1.48604V1.47547Z" fill={color}/>
        <path d="M8.01584 2.90189C8.58641 2.90189 9.04075 2.44755 9.04075 1.87698C9.04075 1.30641 8.58641 0.852074 8.01584 0.852074C7.44528 0.852074 6.99094 1.30641 6.99094 1.87698C6.99094 2.44755 7.44528 2.90189 8.01584 2.90189Z" fill={color}/>
      </g>
      <defs>
        <clipPath id="clip0_4038_62966">
        <rect width="14" height="14.2958" fill="white" transform="translate(1 0.852074)"/>
        </clipPath>
      </defs>
    </svg>
  )
}

IconPause.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconPause;
